import { Card } from "@/components/ui/card";
import { catByValue } from "@/lib/api";
import { fmtDate } from "@/hooks/useCalendarData";
import { MiniJobList } from "./CalendarLists";

const trDay = (d) => d.toLocaleDateString("tr-TR", { weekday: "short", day: "numeric", month: "short" });
const isToday = (d) => fmtDate(d) === fmtDate(new Date());

export const WeeklyGrid = ({ days, jobsByDate }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-3">
    {days.map((d) => (
      <Card key={fmtDate(d)} className={`p-3 border-slate-200 min-h-[180px] ${isToday(d) ? "ring-2 ring-emerald-500" : ""}`}>
        <div className="text-xs font-semibold text-slate-500 uppercase mb-2">{trDay(d)}</div>
        <MiniJobList jobs={jobsByDate[fmtDate(d)] || []} />
      </Card>
    ))}
  </div>
);

const dayCellClass = (inMonth, today) => {
  if (today) return "bg-emerald-50";
  if (!inMonth) return "bg-slate-50 text-slate-300";
  return "";
};

const MonthCell = ({ day, inMonth, jobs }) => {
  const today = isToday(day);
  return (
    <div className={`border border-slate-100 p-2 min-h-[100px] ${dayCellClass(inMonth, today)}`}>
      <div className={`text-xs font-semibold mb-1 ${today ? "text-emerald-700" : ""}`}>{day.getDate()}</div>
      <div className="space-y-1">
        {jobs.slice(0, 3).map((j) => {
          const c = catByValue(j.category);
          return (
            <div key={j.id} className="text-[10px] px-1.5 py-0.5 rounded truncate"
                 style={{ background: c.hex + "20", color: c.hex, borderLeft: `2px solid ${c.hex}` }}>{j.title}</div>
          );
        })}
        {jobs.length > 3 && <div className="text-[10px] text-slate-500">+{jobs.length - 3}</div>}
      </div>
    </div>
  );
};

export const MonthlyGrid = ({ days, anchor, jobsByDate }) => (
  <Card className="p-2 border-slate-200 overflow-hidden">
    <div className="grid grid-cols-7 border-b border-slate-200">
      {["Pzt", "Sal", "Çar", "Per", "Cum", "Cts", "Paz"].map((d) => (
        <div key={d} className="p-2 text-center text-xs font-semibold text-slate-500 uppercase">{d}</div>
      ))}
    </div>
    <div className="grid grid-cols-7">
      {days.map((d) => (
        <MonthCell key={fmtDate(d)} day={d} inMonth={d.getMonth() === anchor.getMonth()} jobs={jobsByDate[fmtDate(d)] || []} />
      ))}
    </div>
  </Card>
);
